export class SubscriptionPurchaseRequestDTO{
    checkoutUrl!: string;
    hasTrial!: boolean;
    isTrial!: boolean;
    message!: string;
    sessionId!: string;

    constructor(data: SubscriptionPurchaseRequestDTO){
        Object.assign(this, data);
    }
}